import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';
import type { ICategoriesApiResponse, ICategoryItem } from '~/modules/categories/types/categories';
import { CATEGORIES_MOCK } from '~/constants/temp/categories';
import type { IProductCategoriesItem } from '~/modules/menu/types/menu';

export default class Categories extends AbstractFetch {
  private static readonly CATEGORIES = 'v1/categories/';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  async getCategories(): Promise<IResponse<ICategoriesApiResponse>> {
    // todo: убрать MOCK
    return CATEGORIES_MOCK;

    return await this.fetch(Categories.CATEGORIES);
  }

  async getProductCategories(): Promise<IResponse<IProductCategoriesItem[]>> {
    const url = Categories.CATEGORIES + '?type=product';

    return await this.fetch(url);
  }
}
